/**
 * Switch between development and production APIs application-wide
 * by swapping comments on the corresponding lines.
 */

//import appApi from './dev'; // dev
import appApi from './prod'; // prod

export default appApi;
